import * as Popover from '@radix-ui/react-popover';
import styles from './SideNavigationSearchCollapsed.module.scss'
import {IconSearch} from '../../../icons';
import classNames from 'classnames';
import {forwardRef, useState} from 'react';
import {
    SideNavigationSearchBar,
    SideNavigationSearchBarProps
} from '../side-navigation-search-bar/SideNavigationSearchBar';
import {SideNavigationToolTip} from '../../side-navigation-collapsed-menu-item-tooltip/SideNavigationToolTip';

export const SideNavigationSearchCollapsed = forwardRef<HTMLInputElement, SideNavigationSearchBarProps>(
    (props, ref) => {

        const [isOpened] = useState<boolean>(false);

        const mainContainerStyling = classNames(
            styles.unsetButton,
            styles.mainContainer,
            {[styles.opened]: isOpened}
        );

        const searchIconStyling = classNames(
            styles.searchIcon,
            {[styles.opened]: isOpened}
        );

        return (
            <Popover.Root modal={false}>
                <SideNavigationToolTip text={'Search'} condition={!isOpened}>
                    <Popover.Trigger className={mainContainerStyling} tabIndex={0}>
                        <IconSearch className={searchIconStyling}/>
                    </Popover.Trigger>
                </SideNavigationToolTip>
                <Popover.Portal>
                    <Popover.Content side={'right'} sideOffset={23}>
                        <>
                            <div className={styles.mainPopoverContentContainer}>
                                <SideNavigationSearchBar ref={ref} {...props}/>
                            </div>
                            <Popover.Arrow className={styles.popoverArrow}/>
                        </>
                    </Popover.Content>
                </Popover.Portal>
            </Popover.Root>
        );
    }
);

SideNavigationSearchCollapsed.displayName = 'SideNavigationSearchCollapsed';